<template>
    <q-item v-bind="$attrs" @click="viewClientProfile">
        <q-item-section>
            <q-item-label>
                <strong>{{ userName }}</strong>
                {{ data.socialSite.name }} account connected.
            </q-item-label>
            <q-item-label caption>
                <slot></slot>
            </q-item-label>
        </q-item-section>
    </q-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface SocialAccountAuthenticated {
  id: number,
  client: {
    id: number,
    firstName: string,
    lastName: string,
  },
  socialSite: {
    id: number,
    type: string,
    name: string,
  }
}

export default defineComponent({
  props: {
    data: {
      type: Object as () => SocialAccountAuthenticated,
      required: true,
    },
  },
  computed: {
    userName(): string {
      return `${this.data.client.lastName}, ${this.data.client.firstName}`;
    },
  },
  methods: {
    viewClientProfile() {
      this.$router.push(`/clients/${this.data.client.id}`);
    },
  },
});
</script>
